import { pathOr } from '../helpers';
import { UNIDAY_UNIVERSITY_STATUSES } from '../../../enums/unidayUniversities';

// status อาจมาเป็น 1/0, '1'/'0' หรือ true/false (flag ของบางโดเมนตอบไม่เหมือนกัน — ดู pitfalls)
export const transformedUnidayUniversityStatus = (status) => {
	if (status === null || status === undefined || status === '') {
		return UNIDAY_UNIVERSITY_STATUSES.ACTIVE;
	}

	return Number(status) === UNIDAY_UNIVERSITY_STATUSES.ACTIVE || status === true
		? UNIDAY_UNIVERSITY_STATUSES.ACTIVE
		: UNIDAY_UNIVERSITY_STATUSES.INACTIVE;
};

const toText = (value) => {
	if (value === null || value === undefined || value === '') {
		return '-';
	}

	return String(value);
};

export const transformedUnidayUniversity = (item = {}) => {
	return {
		id: pathOr(null, ['id'])(item),
		customerId: toText(pathOr(null, ['customer_id'])(item)),
		companyEn: toText(pathOr(null, ['company_en'])(item)),
		companyTh: toText(pathOr(null, ['company_th'])(item)),
		city: toText(pathOr(null, ['city'])(item)),
		state: toText(pathOr(null, ['state'])(item)),
		organizeId: toText(pathOr(null, ['organize_id'])(item)),
		status: transformedUnidayUniversityStatus(pathOr(null, ['status'])(item)),
	};
};

// ค่าดิบสำหรับเติมฟอร์มใน drawer (ไม่แปลงค่าว่างเป็น '-')
export const transformedUnidayUniversityForm = (item = {}) => {
	const toInput = (value) => (value === null || value === undefined ? '' : String(value));

	return {
		id: pathOr(null, ['id'])(item),
		customerId: toInput(pathOr(null, ['customer_id'])(item)),
		companyEn: toInput(pathOr(null, ['company_en'])(item)),
		companyTh: toInput(pathOr(null, ['company_th'])(item)),
		city: toInput(pathOr(null, ['city'])(item)),
		state: toInput(pathOr(null, ['state'])(item)),
		organizeId: toInput(pathOr(null, ['organize_id'])(item)),
		status: transformedUnidayUniversityStatus(pathOr(null, ['status'])(item)),
	};
};

// ฟอร์ม → payload ของ API · ช่องไม่บังคับที่ว่างส่งเป็น null · edit ไม่ส่ง customer_id
export const transformedUnidayUniversityToAPI = (form = {}, { isEditMode = false } = {}) => {
	const toNullable = (value) => {
		const text = value === null || value === undefined ? '' : String(value).trim();
		return text || null;
	};

	const payload = {
		company_en: toNullable(form.companyEn),
		company_th: toNullable(form.companyTh),
		city: toNullable(form.city),
		state: toNullable(form.state),
		organize_id: toNullable(form.organizeId),
		status: transformedUnidayUniversityStatus(form.status),
	};

	if (isEditMode) {
		return payload;
	}

	// BE ต้องการ positive integer
	const customerId = toNullable(form.customerId);

	return {
		customer_id: customerId && /^\d+$/.test(customerId) ? Number(customerId) : customerId,
		...payload,
	};
};

export const transformedUnidayUniversityList = (list = []) => {
	return list.map(transformedUnidayUniversity);
};

/**
 * error ของ import (422) — BE ตอบ `errors` เป็น array ของ string เช่น "row 3 : Customer ID must be ..."
 * (ตาม pattern importer ตัวอื่น) · เผื่อรูปแบบ Laravel `{ field: [msg] }` ไว้ด้วย
 * แปลงเป็น array ของข้อความเพื่อโชว์ใน modal
 */
export const transformedUnidayUniversityImportFileErrors = (responseData = {}) => {
	const errors = pathOr(null, ['errors'])(responseData);
	const message = pathOr(null, ['message'])(responseData);

	if (Array.isArray(errors)) {
		return errors.map(String);
	}

	if (errors && typeof errors === 'object') {
		return Object.values(errors).reduce((acc, value) => acc.concat(value), []).map(String);
	}

	return message ? [message] : [];
};
